import CX from 'classnames'
import React from 'react'
import Select from 'react-select'
import VirtualizedSelect from 'react-virtualized-select'
import Client from '../../client'
import { LoadableSelect } from '../../components/Inputs'

export function Title(props) {
  const maxCharCount = 49
  const invalid = props.value.length > maxCharCount
  return (
    <label className={CX('bp3-label')} style={{ maxWidth: '380px' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        Title
        <span className="bp3-text-muted" style={{ fontSize: '0.8em' }}>{`${props.value.length}/${maxCharCount}`}</span>
      </div>

      <input
        className={CX('bp3-input', { 'bp3-intent-danger': invalid })}
        type="text"
        value={props.value}
        placeholder="New Nike Black Shoes"
        onChange={e => props.onChange(e.target.value)}
        style={{ width: '100%' }}
      />
    </label>
  )
}

export const ConditionPicker = ({ value, onChange }) => (
  <label className="bp3-label">
    Condition
    <div style={{ maxWidth: '167px' }}>
      <Select
        value={value}
        options={[{ label: 'Used', value: 'Used' }, { label: 'New', value: 'New' }]}
        simpleValue
        onChange={onChange}
      />
    </div>
  </label>
)

export function ShippingMethod(props) {
  const defaultProcessor = d => d.carriers.map(s => ({ value: s.id, label: s.name }))
  const processor = props.process || defaultProcessor

  return (
    <label className="bp3-label">
      Shipping Method
      <div style={{ maxWidth: '167px' }}>
        <LoadableSelect load={Client.carriersIndex} process={processor} onChange={v => props.onChange(v)} {...props} />
      </div>
    </label>
  )
}

export function SellerPrivateDescription(props) {
  return (
    <label className="bp3-label">
      Seller Private Description
      <input type="text" className="bp3-input" value={props.value} onChange={e => props.onChange(e.target.value)} />
    </label>
  )
}

export function Suppliers(props) {
  return (
    <LoadableSelect
      load={Client.suppliersIndex}
      process={d => d.suppliers.map(s => ({ value: s.id, label: s.name }))}
      onChange={v => props.onChange(v)}
      {...props}
    />
  )
}

export class InventoryLocation extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      inventoryLocations: []
    }
  }

  componentDidMount() {
    this.fetchInventoryLocations()
  }

  fetchInventoryLocations = async () => {
    this.setState({ loading: true })
    const res = await Client.inventoryLocationIndex()
    this.setState({ inventoryLocations: res.data.inventoryLocations, loading: false })
  }

  render() {
    if (this.state.loading) {
      return <label className="bp3-label">Inventory Location</label>
    }
    const options = this.state.inventoryLocations.map(i => ({ name: i.name, value: i.id }))
    return (
      <label className="bp3-label">
        Inventory Location
        <div style={{ maxWidth: '197px' }}>
          <VirtualizedSelect
            value={this.props.value}
            onChange={v => this.props.onChange(v)}
            labelKey="name"
            valueKey="value"
            simpleValue
            clearable={false}
            options={[...options]}
          />
        </div>
      </label>
    )
  }
}

export function ShippingBox(props) {
  return (
    <LoadableSelect
      load={Client.shippingBoxIndex}
      process={d => d.shippingBoxes.map(s => ({ value: parseInt(s.id, 10), label: s.name }))}
      onChange={v => props.onChange(v)}
      {...props}
    />
  )
}

export class CategoryPicker extends React.Component {
  onChange = (index, value) => {
    const { path } = this.props
    const newPath = path.slice(0, index).concat(value)
    this.props.onChange(newPath.filter(p => p))
  }

  loadFunction = () => this.props.load || Client.marketCategories

  renderSelect = (id, value, index) => (
    <LoadableSelect
      key={id}
      style={{ width: '275px', marginRight: '10px' }}
      hideIfEmpty
      autoload
      value={value}
      load={() => this.loadFunction()(this.props.market, id)}
      process={d => d.data.map(u => ({ value: u.id, label: u.name }))}
      onChange={v => this.onChange(index, v)}
    />
  )

  render() {
    const { path } = this.props
    return (
      <label className="bp3-label">
        Category
        <div style={{ display: 'flex' }}>
          {/* always render the first select */}
          {this.renderSelect(0, path[0], 0)}
          {/* render child nodes */}
          {path.map((id, idx) => this.renderSelect(id, path[idx + 1], idx + 1))}
        </div>
      </label>
    )
  }
}
